import type { QuickSearchResultsProps } from './types'
import { useTranslation } from 'react-i18next'
import { CardSection, ListSection, SectionHeader, SeeAllButton } from '@/components/QuickSearch/Parts'
import { GRID_COLUMNS_MAP, MIXED_CARD_LIMIT, MIXED_HIERARCHY_LIMIT, SINGLE_CARD_LIMIT } from './constants'
import { useQuickSearchLabels } from './quickSearchLabels'

export function QuickSearchResults({
  query,
  response,
  selectedView,
  onResultSelect,
  onSeeAll,
}: Readonly<QuickSearchResultsProps>) {
  const { t } = useTranslation()
  const { SECTION_TITLES } = useQuickSearchLabels()

  const hierarchyMixedResults = [
    ...response.categories.subdepartments.results.slice(0, MIXED_HIERARCHY_LIMIT),
    ...response.categories.families.results.slice(0, MIXED_HIERARCHY_LIMIT),
  ]

  const displayedSupermodels = response.categories.supermodels.results.slice(0, MIXED_CARD_LIMIT)
  const displayedModels = response.categories.models.results.slice(0, MIXED_CARD_LIMIT)

  switch (selectedView) {
    case 'subdepartments':
    case 'families':
      return (
        <ListSection
          query={query}
          results={response.categories[selectedView].results}
          onResultSelect={onResultSelect}
        />
      )
    case 'supermodels':
    case 'models':
      return (
        <CardSection
          query={query}
          results={response.categories[selectedView].results.slice(0, SINGLE_CARD_LIMIT)}
          onResultSelect={onResultSelect}
          gridColumns={GRID_COLUMNS_MAP.SINGLE_CATEGORY}
          action={(
            <SeeAllButton
              category={selectedView}
              total={response.categories[selectedView].total}
              displayed={SINGLE_CARD_LIMIT}
              onSeeAll={onSeeAll}
            />
          )}
        />
      )
    default:
      return (
        <div className="quick-search__sections" data-testid="quick-search-results">
          <div className="quick-search__list-container">
            <SectionHeader title={t('quick-search.hierarchy')} />
            <ListSection
              query={query}
              results={hierarchyMixedResults}
              onResultSelect={onResultSelect}
              displayType
            />
          </div>
          <div className="quick-search__cards-container">
            <div className="quick-search__cards-section">
              <SectionHeader title={SECTION_TITLES.supermodels} iconName="t-shirt-number" />
              <CardSection query={query} results={displayedSupermodels} onResultSelect={onResultSelect} gridColumns={GRID_COLUMNS_MAP.MODAL} />
            </div>
            <div className="quick-search__cards-section">
              <SectionHeader title={SECTION_TITLES.models} iconName="t-shirt" />
              <CardSection query={query} results={displayedModels} onResultSelect={onResultSelect} gridColumns={GRID_COLUMNS_MAP.MODAL} />
            </div>
          </div>
        </div>
      )
  }
}
